/**
 * Vue filter for numbers formatting
 */
export function niceNumberFormatFilter(value) {
    if(!value) {
        return value;
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
